import axios from 'axios';

import { authHeader } from '@H';

export default {
  getCreditCustomerList: () =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/credit-customer/bunk/customer/?credit_customer=`,
    }),
  getOpenDutyList: (date) =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/bunk/cashier/cashier-duties/?date=${date}&is_end_duty=0&is_staff=1`,
    }),
  getPastDutyList: (date) =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/bunk/cashier/cashier-duties/?date=${date}&is_end_duty=1&is_staff=1`,
    }),
  getProductList: (date) =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/bunk/products/list/?date=${date}`,
    }),
  getCustomerVehicles: (credit_customer_id) =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/credit-customer/bunk/vehicle/?credit_customer_id=${credit_customer_id}`,
    }),
  createVehicle: (body) =>
    axios.post(`${process.env.API_URL}/credit-customer/bunk/vehicle/`, body, {
      headers: authHeader(1),
    }),
  bulkRegisterCustomers: (body) =>
    axios.post(`${process.env.API_URL}/bulk-users/register/`, body, {
      headers: authHeader(1),
    }),
  createCreditSlips: (body) =>
    axios.post(
      `${process.env.API_URL}/credit-customer/bunk/credit-slip/`,
      body,
      { headers: authHeader(1) },
    ),
  getStaffList: () =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/staff-management/bunk/staff/`,
    }),
  registerStaff: (body) =>
    axios.post(`${process.env.API_URL}/users/register/`, body, {
      headers: authHeader(1),
    }),
};
